import { LitElement, nothing } from 'lit';
import { customElement } from 'lit/decorators.js';
import { SELECTORS } from '../../constants/selectors';

/**
 * 住所削除コンポーネント
 *
 * @element kd-address-delete
 * @description 住所の削除ボタンを制御する。確認ダイアログ後に Shopify.postLink で削除リクエストを送信。
 */
@customElement('kd-address-delete')
export class KdAddressDelete extends LitElement {
  createRenderRoot() {
    return this;
  }

  private handleDeleteClick = (e: Event): void => {
    const target = e.currentTarget as HTMLElement;
    const confirmMessage = target.getAttribute('data-confirm-message');
    if (!confirmMessage) return;

    // eslint-disable-next-line no-alert, no-restricted-globals
    if (confirm(confirmMessage)) {
      const ShopifyGlobal = (window as unknown as Record<string, unknown>).Shopify as
        | { postLink?: (url: string, options: { parameters: Record<string, string> }) => void }
        | undefined;

      if (ShopifyGlobal?.postLink) {
        ShopifyGlobal.postLink(target.dataset.target!, {
          parameters: { _method: 'delete' },
        });
      }
    }
  };

  connectedCallback(): void {
    super.connectedCallback();

    const deleteButtons = this.querySelectorAll(SELECTORS.ACCOUNT.ADDRESS_DELETE_BUTTON);
    deleteButtons.forEach((btn) => btn.addEventListener('click', this.handleDeleteClick));
  }

  disconnectedCallback(): void {
    super.disconnectedCallback();

    const deleteButtons = this.querySelectorAll(SELECTORS.ACCOUNT.ADDRESS_DELETE_BUTTON);
    deleteButtons.forEach((btn) => btn.removeEventListener('click', this.handleDeleteClick));
  }

  render() {
    return nothing;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'kd-address-delete': KdAddressDelete;
  }
}
